<template>
  <main>
    <div class="l-main-content__inner">
      <div class="c-page-header">
        <h1 class="c-page-header-title">児童/生徒変更（一括）</h1>
          <div class="c-page-header__return">
            <a
              :href="`/teacher/class/${classroomUuid}/student/`"
              class="c-button-white -return -teacher"
            >
              <span class="label">戻る</span>
            </a>
          </div>
      </div>

      <section>
        <div class="c-page-section">
          <div class="c-parts-description">
            <div class="c-parts-description__label">
              <span class="label">年度・学級</span>
            </div>
            <div class="c-parts-description__content">
              <h2 class="heading">{{ classroom?.academic_session.year?? "" }}年度 {{ classroom?.name?? "" }}</h2>
            </div>
          </div>
        </div>

        <div class="c-page-section">
          <ol class="c-step">

            <li class="item on">
              <div class="item__inner">
                <div class="item__title">
                  <figure>
                    <figcaption>STEP1</figcaption>
                    <img src="../../../../djangoapp/assets/teacher/img/common/icon_regi_step1.png" alt="">
                  </figure>
                </div>
                <div class="item__body">
                  <div class="title">
                    テンプレートをダウンロードする
                  </div>
                  <div class="body">
                    <p class="text">右のボタンを押し、名簿テンプレートを保存してください。</p>
                    <div class="btn">
                      <button
                        @click="downloadExcel"
                        class="c-button-blue -small-regular jq_flow1"
                      >
                        <span class="label -download">ダウンロード</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li class="item on">
              <div class="item__inner">
                <div class="item__title">
                  <figure>
                    <figcaption>STEP2</figcaption>
                    <img src="../../../../djangoapp/assets/teacher/img/common/icon_regi_step2.png" alt="" class="adjust1">
                  </figure>
                </div>
                <div class="item__body">
                  <div class="title">
                    名簿データを作成する
                  </div>
                  <div class="body">
                    <p class="text">STEP1でダウンロードしたファイルをパソコンで開き、情報を変更してください。<br>
                    児童/生徒のお名前、出席番号が変更可能です。<br>
                    また、「削除」列に「削除」と入力することで児童/生徒を削除可能です。<br>
                    記入が終わりましたらファイルを保存してください。
                    </p>
                  </div>
                </div>
              </div>
            </li>

            <li class="item on">
              <div class="item__inner">
                <div class="item__title">
                  <figure>
                    <figcaption>STEP3</figcaption>
                    <img src="../../../../djangoapp/assets/teacher/img/common/icon_regi_step3.png" alt="">
                  </figure>
                </div>
                <div class="item__body">
                  <div class="title">
                    名簿をアップロードする
                  </div>
                  <div class="body">
                    <div class="text">
                      <p>右のボタンを押し、STEP2で作成した名簿データをアップロードしてください。</p>
                      <div class="c-parts-alert-message -large">
                        <p>アップロードしたファイルにエラーがない場合、内容が即時に反映されます。<br>
                          「削除」列に入力がある場合、学習履歴をもつ児童/生徒であっても削除されますのでご注意下さい。
                        </p>
                      </div>
                    </div>
                    <div class="btn">
                      <button
                        type="button"
                        class="c-button-blue -small-regular"
                        @click="openUploadModal"
                        >
                        <span class="label -upload">アップロード</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li class="item" :class="{
              'on': importEditResults,
              'item--point': importEditResults?.type === 'success',
              'item--error': importEditResults?.type === 'failure',
            }">
              <div class="item__inner">
                <div class="item__title">
                  <figure>
                    <figcaption>STEP4</figcaption>
                    <img
                      v-if="importEditResults?.type === 'failure'"
                      src="../../../../djangoapp/assets/teacher/img/common/icon_regi_step4_error.png"
                      alt=""
                      class="adjust2"
                    >
                    <img
                      v-else
                      src="../../../../djangoapp/assets/teacher/img/common/icon_regi_step4.png"
                      alt=""
                      class="adjust2"
                    >
                  </figure>
                </div>
                <div class="item__body">
                  <div class="title">
                    登録結果
                  </div>
                  <div class="result">
                    <p v-if="importEditResults?.type === 'failure'" class="errorText" v-html="importEditResults.message"></p>
                    <dl class="list">
                      <dt class="list__title">ファイル名</dt>
                      <dd class="list__data">
                        <p class="text">{{ importEditResults?.fileName ?? '' }}</p>
                      </dd>
                      <dt class="list__title">結果</dt>
                      <dd class="list__data">
                        <p class="text" :class="{
                          'text--success': importEditResults?.type === 'success',
                          'text--error': importEditResults?.type === 'failure',
                          }">
                          <span v-if="importEditResults?.type === 'failure'">失敗</span>
                          <span v-else-if="importEditResults?.type === 'success'">成功<br>（{{ importEditResults.message }}）</span>
                          <span v-else></span>
                        </p>
                      </dd>
                      <dt class="list__title">
                        {{
                          importEditResults?.type === 'failure' ? 'エラー内容' : importEditResults?.type === 'success' ? '登録内容' : ''
                        }}
                      </dt>
                      <dd class="list__data">
                        <div class="c-table-list__wrapper">
                          <div class="c-table-list -status">
                            <dl class="c-table-list__inner">
                              <template v-if="importEditResults?.type === 'success'">
                                <div class="c-table-list__item">
                                  <dd class="status">変更／削除</dd>
                                  <dt>出席番号</dt>
                                  <dd>名前</dd>
                                </div>
                                <div
                                  v-for="(result, index) in importEditResults.results"
                                  class="c-table-list__item"
                                  :class="{
                                    '-delete': ['この学級から削除', '全学級から削除'].includes(result.status),
                                    '-edit': result.status === '変更',
                                  }"
                                  :key="index"
                                >
                                  <dd class="status">{{ result.status?? '' }}</dd>
                                  <dt>{{ result.number }}</dt>
                                  <dd>{{ result.name }}</dd>
                                </div>
                              </template>
                              <template v-if="importEditResults?.type === 'failure'">
                                <div
                                  v-for="(error, index) in importEditResults.errors"
                                  class="c-table-list__item"
                                  :key="index"
                                >
                                  <dd>{{ error }}</dd>
                                </div>
                              </template>
                            </dl>
                          </div>
                        </div>
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
            </li>

            <li class="item item--point" :class="{ 'on': importEditResults?.type === 'success', }">
              <div class="item__inner">
                <div class="item__title">
                  <figure>
                    <img src="../../../../djangoapp/assets/teacher/img/common/icon_regi_step_comp.png" alt="" class="adjust3">
                  </figure>
                </div>
                <div class="item__body">
                  <div class="title">
                    完了
                  </div>
                  <div class="body">
                    <p class="text">名簿が登録されました。</p>
                  </div>
                  <div class="backLink">
                    <a
                      :href="`/teacher/class/${classroomUuid}/student/`"
                      class="c-button-blue -arrow -type01"
                    >
                      <span class="label">前の画面に戻る</span>
                    </a>
                  </div>
                </div>
              </div>
            </li>

          </ol>
        </div>
      </section>
    </div>

    <!-- Excelアップロードモーダル -->
    <upload-modal
      :is-open="isOpenUploadModal"
      @upload="uploadStudentImportEdit"
      @cancel="closeUploadModal"
    ></upload-modal>

    <!-- アップロード中モーダル -->
    <in-progress-modal
      :is-open="isOpenUploadInProgressModal"
      text="アップロード中"
    >
      ただいま登録中です。登録完了後に登録結果が表示されます。<br>
      このままお待ちください。
    </in-progress-modal>

    <error-modal></error-modal>
  </main>
</template>

<script setup lang="ts">
  import { ref, onMounted } from "vue";
  import { useClassroomStore, Classroom, ImportEditResultsSuccess, ImportEditResultsFailure } from "@/store/teacher/classroom_store"

  // TODO: NFR-4808 コンポーネント名など: 配置場所・画面URL変更、に伴い変更する
  const classroomStore = useClassroomStore()

  const props = defineProps<{
    classroomUuid: string
  }>();
  
  const classroom = ref<Classroom | null>(null)
  const isOpenUploadModal = ref(false)
  const isOpenUploadInProgressModal = ref(false)
  const importEditResults = ref<ImportEditResultsSuccess | ImportEditResultsFailure | null>(null)

  onMounted(async() => {
    classroom.value = await classroomStore.retrieveClassroom({ classroom_uuid: props.classroomUuid })
  })

  // アップロードモーダル開閉
  function openUploadModal() {
    isOpenUploadModal.value = true
  }
  function closeUploadModal() {
    isOpenUploadModal.value = false
  }

  // アップロード中モーダル開閉
  function openUploadInProgressModal() {
    isOpenUploadInProgressModal.value = true
  }
  function closeUploadInProgressModal() {
    isOpenUploadInProgressModal.value = false
  }

  /** 一括編集用の生徒名簿エクセルファイルをダウンロードする */
  async function downloadExcel() {
    const response = await classroomStore.downloadStudentsImportEditExcel({
      classroom_uuid: props.classroomUuid
    })
    if (!response) {
      console.log("Failed to download excel file for import edit.")
      return
    }
    const file = window.URL.createObjectURL(new Blob([response.data]))
    const fileName = response.headers["filename"]
    const link = document.createElement("a")
    link.href = file
    link.setAttribute("download", decodeURI(fileName))
    document.body.appendChild(link)
    link.click()
  }

  /** 生徒名簿エクセルファイルをアップロードする */
  async function uploadStudentImportEdit(uploadFile) {
    closeUploadModal()
    openUploadInProgressModal()
    if (!uploadFile) {
      // upload ファイルなかったら送信しない
      console.log("UploadFile is not selected.")
      return
    }

    let formData = new FormData();
    formData.append("students_roster_file", uploadFile)

    importEditResults.value = await classroomStore.importEditStudents({
      classroom_uuid: props.classroomUuid,
      payload: formData,
    })
    closeUploadInProgressModal()
  }
</script>
